import React, { ReactNode } from 'react';
import Box from '../Box/Box';

// https://developer.mozilla.org/en-US/docs/Web/HTML/Block-level_elements
// https://github.com/webmodules/block-elements

type TButtonsBlock = {
  kind?: '' | 'adaptive' | 'fixed';
  children?: ReactNode;
  utilities?: string[];
  className?: string;
  style?: React.CSSProperties;
};

const ButtonsBlock = ({ kind = '', ...rest }: TButtonsBlock) => (
  <Box {...rest} name="ButtonsBlock" modifiers={kind} as="div" />
);

export default ButtonsBlock;
